export enum WrapperType {
  AmbientLight = 'ambient_light_wrapper',
  Audio = 'audio_wrapper',
  Camera = 'camera_wrapper',
  Color = 'color_wrapper',
  Controls = 'controls_wrapper',
  DirectionalLight = 'directional_light_wrapper',
  EnvMap = 'env_map_wrapper',
  Euler = 'euler_wrapper',
  Fog = 'fog_wrapper',
  Fsm = 'fsm_wrapper',
  HemisphereLight = 'hemisphere_light_wrapper',
  LoadingManager = 'loading_manager_wrapper',
  Material = 'material_wrapper',
  Particles = 'particles_wrapper',
  Physics = 'physics_wrapper',
  PointLight = 'point_light_wrapper',
  RectAreaLight = 'rect_area_light_wrapper',
  Renderer = 'renderer_wrapper',
  Scene = 'scene_wrapper',
  SpatialCell = 'spatial_cell_wrapper',
  SpatialGrid = 'spatial_grid_wrapper',
  SpotLight = 'spot_light_wrapper',
  Text2d = 'text_2d_wrapper',
  Text3d = 'text_3d_wrapper',
  Text3dTexture = 'text_3d_texture_wrapper',
  Texture = 'texture_wrapper'
}
